import { CreditCardIcon } from "lucide-react";
import {
	MasterIcon,
	VisaIcon,
	AmexIcon,
	DiscoverIcon,
} from "../../../../../components/ui/icons";
import { CreditCardTypes } from "@/api/credit-cards/credit-cards";

export type CreditCardIconWithVariant = React.FC<
	React.SVGProps<SVGSVGElement> & { variant?: "light" | "dark" }
>;

export type CardTypeConfig = Record<
	CreditCardTypes,
	{
		Icon: CreditCardIconWithVariant;
		bg: string;
	}
>;

export const cardTypeConfig: CardTypeConfig = {
	MASTERCARD: {
		Icon: MasterIcon,
		bg: "bg-primary-600",
	},
	VISA: {
		Icon: VisaIcon,
		bg: "bg-primary-600",
	},
	AMEX: {
		Icon: AmexIcon,
		bg: "bg-primary-600",
	},
	DISCOVER: {
		Icon: DiscoverIcon,
		bg: "bg-primary-600",
	},
	OTHER: {
		Icon: CreditCardIcon,
		bg: "bg-primary-600",
	},
} as const;
